import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonProps } from '@mantine/core';

import { DispatchType } from 'store/dispatch/types';

import { BulkAssignSampler } from './Modals/BulkAssignSampler';

type BulkAssignPropsType = Pick<ButtonProps, 'variant' | 'disabled'> & {
  dispatchPlans: DispatchType[];
  onClose?: VoidFunction;
  onSubmit: VoidFunction;
  label?: string;
};

export const BulkAssignButton = ({
  dispatchPlans,
  onClose,
  onSubmit,
  label,
  ...props
}: BulkAssignPropsType) => {
  const { t } = useTranslation();
  const [menuOpened, setMenuOpened] = useState(false);

  const handleOnClose = () => {
    setMenuOpened(false);
    onClose?.();
  };

  const handleOnSubmit = () => {
    setMenuOpened(false);
    onSubmit();
  };

  return (
    <>
      <Button onClick={() => setMenuOpened(true)} {...props}>
        {label || t('bulkAssign')}
      </Button>
      {menuOpened && (
        <BulkAssignSampler
          dispatchPlans={dispatchPlans}
          onClose={handleOnClose}
          onSubmit={handleOnSubmit}
          opened={menuOpened}
        />
      )}
    </>
  );
};
